'use client'

import { HTMLProps, useState } from 'react'
import clsx from 'classnames'
import { useTranslations } from 'next-intl'
import { motion } from 'framer-motion'
import { Text } from '@/shared/ui'
import { IInfoCard } from '@/interfaces/common'
import { useAppearance } from '@/shared/utils'
import { variantsHeadline } from '@/shared/constants/variants'
import { AccordionItem } from './accodion-item'
import style from './accordion.module.scss'
import { Button } from '../button'

interface AccordionProps extends HTMLProps<HTMLUListElement> {
  title: string
  previewCount?: number
  items: IInfoCard[]
}

export const Accordion = (props: AccordionProps) => {
  const { className, title, items, previewCount = 0 } = props

  const [openId, setId] = useState<number | null>(null)
  const [isMoreShown, setIsMoreShown] = useState(false)
  const translate = useTranslations()

  const canShowMore = (items?.length ?? 0) > previewCount
  const showedItems = isMoreShown ? items : items.slice(0, previewCount)

  const { ref: innerRef, animate } = useAppearance()

  return (
    <motion.section
      ref={innerRef}
      animate={animate}
      variants={variantsHeadline}
      className={clsx(style.container, className)}
    >
      <Text className={style.title} color="dark" type="h2" tagName="h3">
        {title}
      </Text>

      <ul className={clsx(style.accordion, { [style.showMore]: isMoreShown })}>
        {showedItems.map((item: any, index: number) => {
          return (
            <AccordionItem
              key={index}
              onClick={() => (index === openId ? setId(null) : setId(index))}
              {...item}
              isOpen={index === openId}
              isMoreShown={isMoreShown}
            />
          )
        })}
        {canShowMore && !isMoreShown && (
          <Button className={style.buttonMore} type="outline" size="m" onClick={() => setIsMoreShown(true)}>
            {translate('buttonViewAll')}
          </Button>
        )}
      </ul>
    </motion.section>
  )
}
